import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getPsychologistId } from "./api/auth/tokenManager";
import { activityTracker } from "../utils/activityTracker";
import { bindActivityDom } from "../utils/activityDom";

/**
 * Engancha la captura de actividad (Métricas de Actividad) al layout protegido. Se monta UNA
 * vez, en `AppShell`. No renderiza nada y no puede afectar la UI: ver `activityTracker.ts`.
 *
 * Solo trackea sesiones con `psychologist_id` en el JWT (el staff sin psicóloga asociada queda
 * afuera; el backend igual lo descarta). La impersonación NO se filtra acá: el backend la marca
 * como `is_impersonated` desde el JWT y la deja fuera de los KPIs por defecto.
 */
export function useActivityTracker(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!getPsychologistId()) return;
    const unbind = bindActivityDom(activityTracker);
    void activityTracker.start();
    return () => {
      unbind();
      activityTracker.stop();
    };
  }, []);

  // Solo el pathname: el query string (`?patient=`, `?q=`, `?token=`…) nunca llega al tracker.
  useEffect(() => {
    activityTracker.onRouteChange(pathname);
  }, [pathname]);
}
